import { Injectable, signal } from '@angular/core';
import type { ProjectDataRequest } from '@app/models/shared.models';
import type { SelectionItemWithId } from '@app/components/search/multi-select/multi-select.component';

export interface ProjectsPageFiltersSnapshot {
  appliedFilters: Partial<ProjectDataRequest>;
  interestMin: string | null;
  interestMax: string | null;
  yieldMin: string | null;
  yieldMax: string | null;
  durationMin: string | null;
  durationMax: string | null;
  currencies: SelectionItemWithId[];
  locations: SelectionItemWithId[];
  categories: SelectionItemWithId[];
  currentPage: number;
  pageSize: number;
}

@Injectable()
export class ProjectsPageFiltersSyncService {
  private static readonly storageKey = 'pczrt.projectsListing.filters.v1';

  readonly snapshot = signal<ProjectsPageFiltersSnapshot | null>(null);

  constructor() {
    this.hydrateFromStorage();
  }

  private hydrateFromStorage(): void {
    try {
      const raw = localStorage.getItem(
        ProjectsPageFiltersSyncService.storageKey,
      );
      if (!raw) {
        return;
      }
      const parsed = JSON.parse(raw) as ProjectsPageFiltersSnapshot;
      this.snapshot.set(parsed);
    } catch {
      /* ignore corrupt storage */
    }
  }

  save(snapshot: ProjectsPageFiltersSnapshot): void {
    this.snapshot.set(snapshot);
    try {
      localStorage.setItem(
        ProjectsPageFiltersSyncService.storageKey,
        JSON.stringify(snapshot),
      );
    } catch {
      /* quota */
    }
  }
}

export function isExactProjectsListingUrl(url: string): boolean {
  const path = url.split('?')[0].replace(/\/+$/, '') || '/';
  return path === '/projects';
}
